import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User as UserIcon } from "lucide-react";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const initials = user && user.name ? user.name.trim().charAt(0).toUpperCase() : "?";

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10">
      <div className="max-w-5xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="text-[#F43F5E] text-xl">◆</span>
          <span className="font-display font-black text-lg tracking-tight leading-none">
            E SE FOSSE<span className="text-[#F43F5E]"> COMIGO?</span>
          </span>
        </Link>
        {user && (
          <div className="flex items-center gap-2">
            <button
              data-testid="header-profile-btn"
              onClick={() => navigate("/perfil")}
              className="flex items-center gap-2 rounded-full pl-1 pr-3 py-1 bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
            >
              <span className="w-8 h-8 rounded-full bg-gradient-to-br from-[#F43F5E] to-[#8B5CF6] grid place-items-center text-sm font-bold">
                {initials}
              </span>
              <span className="text-sm font-medium hidden sm:block max-w-[120px] truncate">{user.name}</span>
            </button>
            <button
              data-testid="header-logout-btn"
              onClick={async () => { await logout(); navigate("/entrar"); }}
              className="w-9 h-9 grid place-items-center rounded-full bg-white/5 border border-white/10 hover:bg-white/10 text-slate-300 transition-colors"
              title="Sair"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        )}
        {!user && (
          <Link to="/entrar" data-testid="header-login-link"
            className="flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
            <UserIcon className="w-4 h-4" /> Entrar
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
